import {mapLegacyPagination} from '@/store/utils'
import * as mutationTypes from './mutation-types'
import api from '@/store/api/customer/subaccount'

// Modules
import subaccount from './subaccount'

const initialState = () => ({
    subaccounts: {
        data: [],
        pagination: {}
    }
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        subaccounts: state => state.subaccounts.data,
        pagination: state => state.subaccounts.pagination
    },
    actions: {
        listSubaccounts: async ({commit, dispatch}, data) => {
            try {
                const response = await api.listSubaccounts(data)
                const subaccounts = {
                    ...response,
                    pagination: mapLegacyPagination(response.pagination)
                }

                commit(mutationTypes.SET_SUBACCOUNTS, subaccounts)
                return subaccounts
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetSubaccounts: ({commit}) => commit(mutationTypes.RESET_SUBACCOUNTS)
    },
    modules: {
        subaccount
    },
    mutations: {
        [mutationTypes.RESET_SUBACCOUNTS]: (state) => Object.assign(state, initialState()),
        [mutationTypes.SET_SUBACCOUNTS]: (state, data) => state.subaccounts = data
    }
}
